import { Button } from "@/dom/components/Button/Button";
import React from "react";

import css from "./DebugToolbar.module.css";
import { useDebugState } from "@/state/debugState";
import { Panel } from "@/dom/components/Panel/Panel";
import { LightSetup } from "./LighSetup";
import { PanelBody } from "@/dom/components/Panel/PanelBody";

export const DebugToolbar: React.FC = () => {
    const { isSettingUpLighting, setIsSettingUpLighting } = useDebugState();

    return (
        <div className={css.main}>
            <Panel>
                <PanelBody>
                    <Button onClick={() => setIsSettingUpLighting(!isSettingUpLighting)}>
                        {isSettingUpLighting ? "Stop setting up lighting" : "Set up lighting"}
                    </Button>
                    {isSettingUpLighting && <LightSetup />}
                </PanelBody>
            </Panel>
        </div>
    );
};
